import {Component, OnInit} from '@angular/core';
import {TransportesService} from "./transportes.service";
import {TransportesModel} from "./transportes.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";
import {FormBuilder, FormGroup} from "@angular/forms";

declare var swal, $: any;

@Component({
  selector: 'app-transportes',
  templateUrl: './transportes.component.html'
})
export class TransportesComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = {"nome":""};

  transportes: TransportesModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    formBuilder: FormBuilder,
    private transportesService: TransportesService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'transportes'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });

    this.formPesquisaAvancada = formBuilder.group({
      nome: []
    });
  }

  ngOnInit() {
    let filtroSalvo = this.carregaFiltro();
    if (filtroSalvo) {
      this.filtroPesquisa = filtroSalvo;
      this.formPesquisaAvancada.patchValue(filtroSalvo);
    }
    this.getPage(1);
  }

  delete(transporte) {
    let transportes = this.transportes;
    let transportesService = this.transportesService;
    let self = this;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarTransporte')+transporte.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(transportes);
        }

        let index = transportes.indexOf(transporte);
        transportes.splice(index, 1);

        transportesService.apagar(transporte.id_transporte)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.transportes = transportes;
            },
            err => {
              // Revert the view back to its original state
              transportes.splice(index, 0, transporte);
              self.transportes = transportes;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if(this.filtroPesquisa.nome != ''){
      filtros['nome'] = '**:'+this.filtroPesquisa.nome;
    }

    this.transportesService.getPaginacao(pagina,this.itensPorPagina, null, filtros)
      .subscribe(data => {
        this.transportes = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

  modalPesquisaAvancada(){
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada(){
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada(){
    this.filtroPesquisa = {"nome":""};
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }

}



// WEBPACK FOOTER //
// ./src/app/transportes/transportes.component.ts